// SpinnerLoader.jsx
import React from "react";
import styles from "./SpinnerLoader.module.scss";
import { combineClasses } from "utils/utils";

const SpinnerLoader = ({ containerClassName, loaderClassName }) => {
  return (
    <div
      className={combineClasses(styles.spinnerContainer, containerClassName)}
    >
      <div className={combineClasses(styles.loader, loaderClassName)}></div>
    </div>
  );
};

export default SpinnerLoader;
